var render = function render(){var _vm=this,_c=_vm._self._c;return _c('octicon',{attrs:{"name":_vm.name,"aria-hidden":_vm.hidden ? true : undefined,"scale":_vm.scale}})
}
var staticRenderFns = []

export { render, staticRenderFns }